import moment from 'moment';

import { getDateWithoutTimezoneOffset } from 'app/shared/helpers/getDateWithoutTimezoneOffset';
import { LabelEnum } from 'app/shared/enums';
import { DateControlDialogProps } from './DateControlDialog.interfaces';

const weekdayNames = new Map<number, string>([
  [0, 'Niedziela'],
  [1, 'Poniedziałek'],
  [2, 'Wtorek'],
  [3, 'Środa'],
  [4, 'Czwartek'],
  [5, 'Piątek'],
  [6, 'Sobota'],
]);

const shortWeekdayNames = new Map<number, string>([
  [0, 'niedz'],
  [1, 'pon'],
  [2, 'wt'],
  [3, 'śr'],
  [4, 'czw'],
  [5, 'pt'],
  [6, 'sob'],
]);

const monthNames = new Map<number, string>([
  [0, 'styczeń'],
  [1, 'luty'],
  [2, 'marzec'],
  [3, 'kwiecień'],
  [4, 'maj'],
  [5, 'czerwiec'],
  [6, 'lipiec'],
  [7, 'sierpień'],
  [8, 'wrzesień'],
  [9, 'październik'],
  [10, 'listopad'],
  [11, 'grudzień'],
]);

const getWeekday = (date: Date): string => {
  return weekdayNames.get(date.getDay()) || '';
};

export const getShortWeekday = (locale: string, date: Date): string => {
  return shortWeekdayNames.get(date.getDay()) || '';
};

export const getMonthName = (locale: string, date: Date): string => {
  return monthNames.get(date.getMonth()) || '';
};

export const getMonthYear = (locale: string, date: Date): string => {
  return getMonthName('', date) + ' ' + date.getFullYear();
};

export function useDateControlDialog({
  initialFocusedDate,
  minDate,
  maxDate,
  startDate,
}: DateControlDialogProps) {
  const getDayName = (n: number, day: Date) => {
    switch (n) {
      case 0:
        return LabelEnum.Today;
      case 1:
        return LabelEnum.Tomorrow;
      case 2:
        return LabelEnum.DayAfterTomorrow;
      default:
        return getWeekday(day);
    }
  };

  const getCalendarMinDate = () => {
    const date = moment.utc(minDate, true).toDate();
    return getDateWithoutTimezoneOffset(date);
  };

  const getCalendarMaxDate = () => {
    const date = moment.utc(maxDate, true).toDate();
    return getDateWithoutTimezoneOffset(date);
  };

  const toDate = (date: string | undefined) => {
    if (!date) {
      return undefined;
    }

    const parsedDate = moment(date);

    return parsedDate.isValid() ? parsedDate.toDate() : undefined;
  };

  const getCalendarActiveStartDate = () => {
    return (
      toDate(initialFocusedDate) ||
      toDate(startDate) ||
      toDate(minDate) ||
      new Date()
    );
  };

  return {
    getDayName,
    getCalendarMinDate,
    getCalendarMaxDate,
    getCalendarActiveStartDate,
    getMonthYear,
    getShortWeekday,
    getMonthName,
  };
}
